import React from "react";
import get from "lodash/get";
import compose from "lodash/flowRight";
import { connect } from "react-redux";

import SignUp from "auth/SignUp";
import SignUpExistingUser from "auth/SignUpExistingUser";
import SignUpWithToken from "auth/SignUpWithToken";
import withDocumentTitle from "utils/withDocumentTitle";
import { isEmailAddressInUse } from "auth/modules/sign-up";

const isTokenSignup = get(window, "Auth.signup_with_token", false);

class Register extends React.Component {
  componentDidMount() {
    handleExistingUserSession();
  }

  render() {
    const { isExistingUser, match } = this.props;
    if (isTokenSignup) return <SignUpWithToken />;
    else if (isExistingUser) return <SignUpExistingUser />;
    else return <SignUp edition={match.params.edition} />;
  }
}

// Redirect any user with an existing SWICUS session to the SWICUS-provided
// login-or-signup page.
function handleExistingUserSession() {
  const sessionCheckUri = window.Auth.swicus_session_check_uri;
  fetch(sessionCheckUri, { credentials: "include" })
    .then(response => {
      if (response.ok) return response.json();
    })
    .then(json => (window.location = `${json.location}?product=appoptics`))
    .catch(error => null);
}

function mapStateToProps(state, props) {
  return {
    isExistingUser: isEmailAddressInUse(state, props),
  };
}

export default compose(connect(mapStateToProps), withDocumentTitle("Sign Up"))(
  Register
);
